export const ENTITY_TYPES = {
  PRESENTATION: 'presentation',
  SCHEDULE: 'schedule',
  DISPLAY: 'display',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];
